<template>
  <SliderProducts :productItems="productItems"/>
</template>

<script>
import SliderProducts from '@/components/products/SliderProducts.vue';

export default {
  components: {
    SliderProducts,
  },
  data() {
    return {
      productItems: [{
        picture: '/images/banners/products/crop-area.jpg',
        name: 'Классификация посевных площадей',
        path: 'crop-area',
        isLink: true,
      },
      {
        picture: '/images/banners/products/forecast.jpg',
        name: 'Прогноз урожайности',
        path: 'forecast',
        isLink: true,
      },
      {
        picture: '/images/banners/products/yield-eval.jpg',
        name: 'Оценка урожайности',
        path: 'yield-eval',
        isLink: true,
      },
      {
        picture: '/images/banners/products/loss-eval.jpg',
        name: 'Оценка ущерба',
        path: 'loss-eval',
        isLink: true,
      },
      {
        picture: '/images/banners/products/rank-agro.jpg',
        name: 'Оценка и ранжирование сельскохозяйственных земель',
        path: 'rank-agro',
        isLink: true,
      },
      {
        picture: '/images/banners/products/invasive.jpg',
        name: 'Борьба с инвазивными видами растений',
        path: 'invasive-plants',
        isLink: true,
      },
      {
        picture: '/images/banners/products/obs-media.jpg',
        name: 'Мониторинг тематических СМИ на территориях проведения исследований',
        path: 'obs-media',
        isLink: true,
      },
      {
        picture: '/images/banners/products/weather.jpg',
        name: 'Мониторинг и прогнозирование метеоусловий',
        path: 'obs-weather',
        isLink: true,
      },
      ],
    };
  },
};
</script>
